<mat-card class="dark-blue">
  <img mat-card-image class="az-card" src="assets/img/404-Fehler.jpg">
  <mat-list>
    <mat-card-title><b>Diese Seite konnte nicht nicht gefunden werden.</b></mat-card-title>
    <mat-card-content>
      <p style="font-size:20px;">
        Gründe dafür könnten sein, dass Sie eine falsche oder veraltete URL aufgerufen haben - bitte überprüfen Sie diese noch mal.
      </p>
      <p style="font-size:20px;">
        Vielleicht können Sie den von Ihnen gewünschten Inhalt über unsere Startseite finden.
      </p>
      <mat-divider></mat-divider>
      <a mat-button color="primary" class="text-upper push-top-sm" (click)="goToStartseite()">
        <span>Zur Startseite</span>
      </a>
    </mat-card-content>
  </mat-list>
</mat-card>
